export const ATTENDEE_ELIGIBILITY = {
  ALL: 'all',
  MALE: 'male',
  FEMALE: 'female',
};

export const ATTENDEE_ELIGIBILITY_OPTIONS = [
  { value: ATTENDEE_ELIGIBILITY.ALL, label: 'All Genders' },
  { value: ATTENDEE_ELIGIBILITY.MALE, label: 'Male Only' },
  { value: ATTENDEE_ELIGIBILITY.FEMALE, label: 'Female Only' },
];

const LEGACY_ATTENDEE_ELIGIBILITY_MAP = {
  all_genders: ATTENDEE_ELIGIBILITY.ALL,
  male_only: ATTENDEE_ELIGIBILITY.MALE,
  female_only: ATTENDEE_ELIGIBILITY.FEMALE,
};

export const normalizeAttendeeEligibility = (value) => {
  if (!value) return ATTENDEE_ELIGIBILITY.ALL;

  const normalized = String(value).trim().toLowerCase();
  if (Object.values(ATTENDEE_ELIGIBILITY).includes(normalized)) {
    return normalized;
  }

  return LEGACY_ATTENDEE_ELIGIBILITY_MAP[normalized] ?? ATTENDEE_ELIGIBILITY.ALL;
};

export const getAttendeeEligibilityLabel = (value) =>
  ATTENDEE_ELIGIBILITY_OPTIONS.find(
    (option) => option.value === normalizeAttendeeEligibility(value),
  )?.label ?? '—';

export const isValidAttendeeEligibility = (value) =>
  ATTENDEE_ELIGIBILITY_OPTIONS.some(
    (option) => option.value === normalizeAttendeeEligibility(value),
  );

/** API expects `all` | `male` | `female`. */
export const formatAttendeeEligibilityForApi = (value) => normalizeAttendeeEligibility(value);

export const REQUIRE_JOIN_APPROVAL_COPY = {
  event: {
    title: 'Require Host Approval',
    description:
      'Attendees must be reviewed and approved before receiving a confirmed spot at the event.',
    bullets: [
      'Registrations enter a Pending Approval state',
      'Organizers can approve or reject attendees from the Guest List',
      'Approved attendees automatically receive a confirmation email',
    ],
    ariaLabel: 'Require host approval',
  },
  community: {
    title: 'Require Admin Approval',
    description: 'New members must be approved before joining.',
    bullets: [],
    ariaLabel: 'Require admin approval',
  },
};

export const ATTENDEE_ELIGIBILITY_COPY = {
  event: {
    description: 'Control who can register for this event.',
    infoAlert: 'Gender restrictions will be displayed on the event page before registration.',
  },
  community: {
    description: 'Control who can join this community.',
    infoAlert: '',
  },
};
